import { RETRIEVE_BY_ID } from '@inpart-io/devtools-vue';
import { CreationPermissionSettingValues, type IListBehaviorConfiguration } from '@inpart-io/padme-iap';
import { listBehaviorConfigurationProperties } from '@inpart-io/padme-iap';
import { computed, type ComputedRef, watchEffect } from 'vue';
import { useStore } from 'vuex';

import { LIST_BEHAVIOR_CONFIGURATION_MODULE } from '@/store/list-behavior-configuration-module';
import { GET_FROM_TARGET_VALUE } from '@/store/list-behavior-configuration-module/getters';

import { usePermissionHelper } from './usePermissionHelper';

export function useListBehaviorHelper(targetValue: string): {
    isAllowedToCreate: ComputedRef<boolean>;
} {
    const store = useStore();
    const { isManager, isBusinessAdmin, isTechnicalAdmin } = usePermissionHelper();

    const listBehaviorConfig = computed<IListBehaviorConfiguration>(() => {
        return store.getters[`${LIST_BEHAVIOR_CONFIGURATION_MODULE}/${GET_FROM_TARGET_VALUE}`](targetValue);
    });

    const isAllowedToCreate = computed<boolean>(() => {
        if (listBehaviorConfig.value?.creationType === CreationPermissionSettingValues.ALL) {
            return isManager.value || isBusinessAdmin.value || isTechnicalAdmin.value;
        }
        return isBusinessAdmin.value || isTechnicalAdmin.value;
    });

    watchEffect(() => {
        if (listBehaviorConfig.value !== null && listBehaviorConfig.value !== undefined) {
            void store.dispatch(`${LIST_BEHAVIOR_CONFIGURATION_MODULE}/${RETRIEVE_BY_ID}`, {
                dobjId: listBehaviorConfig.value.dobjId,
                properties: listBehaviorConfigurationProperties.DEFAULT
            });
        }
    });

    return {
        isAllowedToCreate
    };
}
